import React, { useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useAccess } from 'contexts/access'
import { useUpgradable } from 'hooks/upgradable'
import { useParams } from 'react-router-dom'
import { compact } from 'utilities/array'
import { Field, Label, Control, ValueDisplay } from 'components/form/field/s'
import ItemMeta from 'components/item-meta'
import { Button } from './s'
import LanguageLegislation from 'pages/documents/components/language-legislation'
import { SmartDocument } from 'components/feather'
import Upgrade from 'modals/upgrade'

const DocumentReference = ({ dokument, preview, salt }) => {
    const { formatMessage } = useIntl()

    const { checkFeature } = useAccess()
    const checkUpgradable = useUpgradable()

    const { id } = useParams()

    const [upgrading, setUpgrading] = useState(null)

    const smartDocumentsAvailable = checkFeature('smart-documents')
    const smartDocumentsUpgradable = checkUpgradable({ feature: 'smart-documents' })

    const metaProps = {
        as: Button,
        onClick: () => preview(dokument)
    }

    const isSameDocument = id === dokument.id

    if(isSameDocument || (!smartDocumentsAvailable && !smartDocumentsUpgradable)) {
        metaProps.as = 'div'
        delete metaProps.to
        delete metaProps.onClick
    }

    if(!smartDocumentsAvailable && smartDocumentsUpgradable) {
        metaProps.as = Button
        metaProps.onClick = () => setUpgrading({
            upgrade: {
                feature: 'smart-documents'
            }
        })
    }

    const name = compact([
        `${dokument.name}.smart`,
        isSameDocument && `(${formatMessage({
            id: 'document_label_this_document',
            defaultMessage: 'This'
        })})`.toLowerCase()
    ]).join(' ')

    return (
        <>
            <Field>
                <Label>
                    <FormattedMessage
                        id="documents_smart_label_document_reference"
                        defaultMessage="Based on smart document" />
                </Label>
                <Control>
                    <ValueDisplay>
                        <ItemMeta
                            {...metaProps}
                            className="wrapped"
                            icon={<SmartDocument size={20} />}
                            name={name}
                            meta={{
                                text: (
                                    <LanguageLegislation
                                        wrap={false}
                                        language={dokument?.language}
                                        legislation={dokument?.legislation} />
                                ),
                                className: 'interpoint-divider'
                            }}
                            upgradable={smartDocumentsUpgradable} />
                    </ValueDisplay>
                </Control>
            </Field>
            <Upgrade
                {...upgrading}
                dismiss={() => setUpgrading(null)}
                salt={`${salt}:smart-document-reference:upgrade`} />
        </>
    )
}

export default DocumentReference